import axios from "axios";

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace(/\/$/, "");

export const fetchMRoyTests = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/m-roy-tests/`, { headers, params });
  return res.data;
};

export const createMRoyTest = async (token, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.post(`${API}/m-roy-tests/`, payload, { headers });
  return res.data;
};

export const updateMRoyTest = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.patch(`${API}/m-roy-tests/${id}/`, payload, { headers });
  return res.data;
};

export const deleteMRoyTest = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/m-roy-tests/${id}/`, { headers });
};

export const fetchMRoyRecords = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/m-roy-records/`, { headers, params });
  return res.data;
};

export const fetchMRoyRecord = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/m-roy-records/${id}/`, { headers });
  return res.data;
};

export const createMRoyRecord = async (token, formData) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.post(`${API}/m-roy-records/`, formData, { headers });
  return res.data;
};

export const updateMRoyRecord = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.patch(`${API}/m-roy-records/${id}/`, payload, { headers });
  return res.data;
};

export const deleteMRoyRecord = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/m-roy-records/${id}/`, { headers });
};
